import { Injectable } from '@angular/core';
import { Template } from '../models/template';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root',
})
export class OfferdbService {
  constructor(private http: HttpClient) {}

  // dummydata
  template_data: Template[] = [
    {
      requisitionId: 13,
      applicationid: 967,
      candidateid: 1000000018,
      unitcode: 'ENG',
      status: ['Selected', 'Rejected'],
    },
    {
      requisitionId: 14,
      applicationid: 968,
      candidateid: 1000000019,
      unitcode: 'ENG',
      status: ['Selected', 'Rejected'],
    },
  ];

  baseUrl: string = environment.offerDBUrl;
  offerwfUrl: string = environment.offerWF;
  recruiterDashboardUrl: string = environment.recruiterdashboardUrl;

  download_template(eventId): Observable<Template[]> {
    // if(!!eventId)
    // {
    //   eventId = 63;
    // }
    return this.http.get<Template[]>(this.baseUrl + 'geteventcandidatedata?eventid=' + eventId);
  }

  uploadEventCandidateData(fileData): Observable<any> {
    return this.http.post(this.baseUrl + 'getDashboardNumbers', fileData);
  }

  postRecruiterData(postRecData) {
    // postRecruiterData(postRecData)
    // {
    if (localStorage.getItem('fresherCompHiringTypeId') == '6') {
      return this.http.post<any[]>(this.offerwfUrl + 'v1/ILChinadashboard/getExceptionalCandidates', postRecData);
    } else {
      return this.http.post<any[]>(this.offerwfUrl + 'v1/dashboard/getExceptionalPriorityCandidates', postRecData);
    }
    // }
    // return this.http.post("http://localhost:8081//v1/dashboard/getExceptionalCandidates",postRecData)
  }
  // unblockIndent(applicationId,indentmodal){
  //   return this.http.post("https://intaptest.infosysapps.com/infosys/intapofferwf/v1/indent/reOpenILIndents/"+applicationId,indentmodal,{'responseType':'json'})
  // }
  // download_template():Observable<Template[]>
  // {
  //   // return {requisitionId:13,applicationid:967,candidateid:1000000018,unitcode:"ENG"};
  //   return of(this.template_data);
  //   // return this.http.get<Template[]>(this.baseUrl + "/geteventcandidatedata?eventid=1");

  // }

  restrictSpclCharRePropose(e) {
    const keyRePropose = document.all ? e.keyCode : e.which;
    return (
      (keyRePropose > 64 && keyRePropose < 91) ||
      (keyRePropose > 96 && keyRePropose < 123) ||
      keyRePropose == 8 ||
      keyRePropose == 32 ||
      (keyRePropose >= 48 && keyRePropose <= 57) ||
      keyRePropose == 45 ||
      keyRePropose == 46 ||
      keyRePropose == 44
    );
  }

  rstrctPasteSpclCharRePropose(eRePropose) {
    if (eRePropose && eRePropose.clipboardData && eRePropose.clipboardData.getData('text')) {
      if (!eRePropose.clipboardData.getData('text').match('^[a-zA-Z0-9 .,-]*$')) {
        return false;
      }
    }
  }

  // Candidates Inbox API Methods
  getCandidatesInbox(screenName: string): Observable<any[]> {
    return this.http.get<any[]>(this.recruiterDashboardUrl + 'v1/offerDeo/inbox?screenName=' + screenName);
  }

  // Get Offer DEO list (using deoAssignment API)
  getOfferDeoList(roleCode: string): Observable<any[]> {
    return this.http.get<any[]>(this.recruiterDashboardUrl + 'v1/deoList/' + roleCode);
  }

  // Update Assignee Offer DEO
  updateAssigneeOfferDeo(updateData: any): Observable<any> {
    return this.http.post<any>(this.recruiterDashboardUrl + 'v1/deo/reAssign', updateData);
  }

  getHrOfferDbCandidatesList(screenName) {
    return this.http.get<any[]>(`${this.recruiterDashboardUrl}v1/offerDeo/inbox?screenName=${screenName}`);
  }

  getHrOfferDbCandidateDetails(candidateId?: number | string, applicationId?: number | string) {
    return this.http.get<any>(
      this.recruiterDashboardUrl + 'v1/hrOfferDbActivity/candidate/' + candidateId + '/' + applicationId,
    );
  }

  hrOfferDbApproveReject(payload): Observable<any> {
    return this.http.post(this.recruiterDashboardUrl + 'v1/hrOfferDbActivity/process', payload);
  }

getRejectionReasons(): Observable<any> {
  return this.http.get<any>(this.recruiterDashboardUrl + '/v1/hrOfferDbActivity/rejectionReasons/1');
}

getDnhCheck(activityId: number | string, candidateId: number | string): Observable<any> {
  return this.http.get<any>(this.offerwfUrl + '/v1/dnh/doNotHireCheck/' + activityId + '/' + candidateId);
}

getHrCheckDetails(applicationId: number | string): Observable<any> {
  return this.http.get<any>(this.recruiterDashboardUrl + 'v1/Hrpanel/getHrCheckDetails?application_id=' + applicationId);
}

}
